import { Dispatch } from 'redux';
import { fetchSubscriptionTypes } from '../../services/subscriptionType.service';
import { CustomErrorResponse } from '../../types/customError/response';
import { SubscriptionType } from '../../types/subscriptionType/response';
import {
  SubscriptionTypes,
  SUBSCRIPTION_TYPES_ERROR,
  SUBSCRIPTION_TYPES_SUCCESS,
  LOADING_SUBSCRIPTION_TYPES,
  SELECT_SUBSCRIPTION_TYPE,
} from '../config/ActionTypes';

const isSubscriptionType = (object: SubscriptionType[] | CustomErrorResponse): boolean => {
  return !('errorCode' in object);
};

export const getSubscriptionType = (subscriptionTypeId: number | undefined) => {
  return (dispatch: Dispatch<SubscriptionTypes>) => {
    dispatch(loadingSubscriptionTypes());

    return fetchSubscriptionTypes(subscriptionTypeId).then(
      (response) => {
        if (isSubscriptionType(response)) {
          const subscriptionTypesResponse = response as SubscriptionType[];
          const selectedSubscriptionType =
            process.env.REACT_APP_CAN_CHOOSE_SUBSCRIPTION && subscriptionTypeId
              ? subscriptionTypesResponse.filter((subscription) => subscription.id === subscriptionTypeId)[0]
              : subscriptionTypesResponse[0];
          dispatch(subscriptionTypesSuccess(subscriptionTypesResponse, selectedSubscriptionType));
        }
      },
      (error) => {
        dispatch(subscriptionTypesFailed(error));
      },
    );
  };
};

export const loadingSubscriptionTypes = (): SubscriptionTypes => ({
  type: LOADING_SUBSCRIPTION_TYPES,
});

export const subscriptionTypesSuccess = (
  subscriptionTypes: SubscriptionType[],
  selectedSubscriptionType: SubscriptionType | null,
): SubscriptionTypes => ({
  type: SUBSCRIPTION_TYPES_SUCCESS,
  subscriptionTypes,
  selectedSubscriptionType,
});

export const subscriptionTypesFailed = (error: string): SubscriptionTypes => ({
  type: SUBSCRIPTION_TYPES_ERROR,
  error,
});

export const selectSubscriptionType = (subscriptionTypeId: string): SubscriptionTypes => ({
  type: SELECT_SUBSCRIPTION_TYPE,
  subscriptionTypeId,
});
